import { LayerType, type IExportBehavior, type ILayerBehavior } from '@/version-types';
import {
    createOperationBehaviors,
    createRendererBehaviors,
    createSaveBehaviors,
    createTextBehaviors,
} from './behaviors';

const getBehavior = (identity: string) => {
    const rendererBehaviors = createRendererBehaviors(identity);
    const saveBehaviors = createSaveBehaviors(identity);
    const textBehaviors = createTextBehaviors(identity);
    const operationsBehaviors = createOperationBehaviors(identity);

    const layerBehavior: ILayerBehavior = {
        ...rendererBehaviors,
        ...saveBehaviors,
        ...textBehaviors,
        ...operationsBehaviors,
    };

    return layerBehavior;
};

export default {
    layerType: LayerType.VECTOR_LAYER,
    getBehavior,
} as IExportBehavior;
